import {ObjectFactory} from "@commons/types";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";

export type TipoElementoRML = 'ALTRO' | 'NAZIONALE' | 'TERRITORIALE' | 'AD_PERSONAM' | null;

interface ElementoRMLFormData {
    codElemento: string | null,
    tipo: TipoElementoRML,
    descrizione: string | null,
    note: string | null,
    elementoDiscrezionale: boolean | string | null,
    sortOrder: number,
}

export interface ElementoRMLRecord extends ElementoRMLFormData, URIAndTrace {
}

export class ElementoRMLRecord {
    static factory: ObjectFactory<ElementoRMLRecord> = (json?) => {
        return {
            codElemento: (json && json.codElemento) ? json.codElemento : null,
            descrizione: (json && json.descrizione) ? json.descrizione : null,
            note: (json && json.note) ? json.note : null,
            elementoDiscrezionale: (json && json.elementoDiscrezionale) ? json.elementoDiscrezionale : null,
            tipo: (json && json.tipo) ? json.tipo : null,
            sortOrder: (json && json.sortOrder) ? json.sortOrder : 100,
            URI: null,
        };
    }
}